import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AnthologyWriterForm from '../forms/anthology-writer-form';
import { anthologyWriterValidationSchema } from '../schema/anthologyWriter.js';

export default function AnthologyWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Anthology Writer Details',
        altText: 'Anthology Writer',
        defaultLabel: 'Anthology Writer',
      }}
    >
      <CommonNode
        FormComponent={AnthologyWriterForm}
        schemaResolver={anthologyWriterValidationSchema}
      />
    </NodeProvider>
  );
}
